var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.829,
    height: 17.268,
    viewBox: "0 0 15.829 17.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M15.039,198.982,12,197.839a1.913,1.913,0,0,0-1.873.356l-.754.635s-.262-.1-.618-.263c0,0-3.381-2.649-4.144-4.96-.025-.076-.042-.152-.068-.22-.067-.229-.1-.389-.1-.389l.746-.644a1.9,1.9,0,0,0,.643-1.786l-.643-3.182c-1.4-2.6-4.381.533-4.381.533a6.049,6.049,0,0,0-.458,5.053c.017.093.907,4.85,6.728,8.829a6.749,6.749,0,0,0,6.728,1.422s3.567-2.447,1.237-4.233Z",
    transform: "translate(0 -186.355)",
    fill: "#e4001b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.0150d786f0e3cb96d864dab077face12.svg";
export { ForwardRef as ReactComponent };